/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import Select from 'react-select';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { PanelStyle } from '../../constants';
import history from '../../core/history';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import ProgressBar from 'react-bootstrap/lib/ProgressBar';

const {
  errorSpanStyle,
} = PanelStyle;


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

class OdpadyInfo extends React.Component {
  state = {
    jobId: null,
    isWorking: false,
    progress: 0,
    cities: null,
    choosedCity: null,
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
  };

  spanStyle = {
    color: 'red',
  };

  validators = {};

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservices/${this.props.district}/odpady`)
    .then(r => r.json())
    .then(resp => {
      this.setState({
        cities: resp.cities
      })
    })
  }

  onHide = () => this.setState({ showError: false });

  onChange = (e) => {
    this.setState({
        choosedCity: e.value
      }
    );
  };

  runService = () => {
    if (this.state.choosedCity === null)
      return;

    // /eservices/<string:teryt>/service/<string:serviceType>
    const url = `${process.env.API_URL}/eservices/${this.props.district}/service/${this.props.serviceInfo.eservice.shortName}`;
    let data = {
      'dzialki': [],
      'shortName': this.props.serviceInfo.eservice.shortName,
      'street': this.state.choosedCity
    }

    const odp = fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(r => {
      if (r.status === 200) {
        return r.json();
      }
      throw new Error('Blad');
    })
    .then(resp => {
      // returnsDoc: true,
      if (this.props.serviceInfo.eservice.returnsDoc) {
        window.location.href = `${process.env.API_URL}/eservices/${this.props.district}/getDoc/${resp.fileName}`;
      } else {
        this.setState({ jobId: resp.message, isWorking: true }, () => this.getJobStatus());
      }
    })
    .catch(err => {
      // TODO: create modal info, with message: Błąd po stronie serwera wróc za 10 min
      console.info('HABIBI07: err', err);
    });
  }

  getJobStatus = () => fetch(`${process.env.API_URL}/service/status/${this.state.jobId}`, { method: 'GET' })
  .then(r => r.json())
  .then(resp => {
    this.setState(
    { jobStatus: resp, progress: this.state.progress !== 99 ? this.state.progress + 0.5 : 99, modalBody: <div>
      <ProgressBar active now={this.state.progress} label={`${this.state.progress}%`} />
      <p>
        Trwa generowanie Twojego dokumentu, w zależności od złożoności dokumentu generowanie może trwać od 30s do około 2 minut.
      </p>
    </div>, modalText: 'Generowanie dokumentu...' },
    () => {
        if (resp.status === 'started') {
          setTimeout(this.getJobStatus, 50); //: (resp.status === 'finished') ? this.onJobFinish(resp) : this.setState({ isWorking: false })
        }
        if (resp.status === 'finished') {
          this.onJobFinish(resp);
        }
        if (resp.status === 'failed'){
          this.onJobFailed()
        }

      })
    }
  );

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title.toUpperCase()}
        </h3>
        <GrayPanel
          title={'1. Punkt odbioru'}
        >
          <p>Wybierz punkt odbioru</p>
          <Select
            options={this.state.cities ? this.state.cities : null}
            value={this.state.choosedCity}
            onChange={(e) => this.onChange(e)}
            onBlur={event => event.preventDefault()}
            optionClassName="needsclick"
            blurInputOnSelect={false}
          />
        </GrayPanel>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ progress: 0 }, () => this.runService())}
            >
              Uruchom
            </button>
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

OdpadyInfo.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default connect(mapState, mapDispatch)(OdpadyInfo);



// WEBPACK FOOTER //
// src/routes/eservices/OdpadyInfo.js